import { render, staticRenderFns } from "./salesTreatment.vue?vue&type=template&id=6c8f6636&scoped=true"
import script from "./salesTreatment.vue?vue&type=script&lang=js"
export * from "./salesTreatment.vue?vue&type=script&lang=js"
import style0 from "./salesTreatment.vue?vue&type=style&index=0&id=6c8f6636&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f6636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8f6636')) {
      api.createRecord('6c8f6636', component.options)
    } else {
      api.reload('6c8f6636', component.options)
    }
    module.hot.accept("./salesTreatment.vue?vue&type=template&id=6c8f6636&scoped=true", function () {
      api.rerender('6c8f6636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/salesTreatment.vue"
export default component.exports